import { get } from 'utils/lodash';

export const getEWalletNewFavPayload = state => {
  const isFromTransferResult = get(state, 'isFromTransferResult', false);
  const fromAccountNumber = get(state, 'senderAccount.accountNumber', '');
  const fromCurrencyCode = get(state, 'senderAccount.currencyCode', '');
  const fromCurrency = get(state, 'senderAccount.currency', '');
  const accountHolderName = get(state, 'accountHolderName', '');

  return {
    userId: get(state, 'userId', ''),
    payeeCode: get(state, 'payeeCode', ''),
    payeeName: get(state, 'payeeName', ''),
    toAccountNo: get(state, 'toAccountNo', ''),
    accountNickname: get(state, 'accountNickname', ''),
    ...(!isFromTransferResult ? { fromAccountNumber, fromCurrency, fromCurrencyCode } : { accountHolderName }),
  };
};

export const getSknNewFavPayload = state => {
  const isFromTransferResult = get(state, 'isFromTransferResult', '');
  return {
    userId: get(state, 'userId', ''),
    toAccountNo: get(state, 'toAccountNo', ''),
    accountLimit: get(state, 'accountLimit', ''),
    emailAddress: get(state, 'emailAddress', ''),
    accountNickname: get(state, 'accountNickname', ''),
    accountHolderName: get(state, 'accountHolderName', ''),
    bankCode: isFromTransferResult ? get(state, 'bankCode', '') : get(state, 'bankCode.value', ''),
  };
};

export const getInterbankNewFavPayload = state => {
  const isFromTransferResult = get(state, 'isFromTransferResult', '');
  return {
    userId: get(state, 'userId', ''),
    toAccountNo: get(state, 'toAccountNo', ''),
    emailAddress: get(state, 'emailAddress', ''),
    accountNickname: get(state, 'accountNickname', ''),
    bankCode: isFromTransferResult ? get(state, 'bankCode', '') : get(state, 'bankCode.value', ''),
  };
};

export const getRtgsNewFavPayload = state => {
  const isFromTransferResult = get(state, 'isFromTransferResult', '');
  return {
    userId: get(state, 'userId', ''),
    toAccountNo: get(state, 'toAccountNo', ''),
    emailAddress: get(state, 'emailAddress', ''),
    accountLimit: get(state, 'accountLimit', ''),
    accountNickname: get(state, 'accountNickname', ''),
    accountHolderName: get(state, 'accountHolderName', ''),
    bankCode: isFromTransferResult ? get(state, 'bankCode', '') : get(state, 'bankCode.value', ''),
  };
};

export const getVirtualAccountNewFavPaylaod = state => ({
  userId: get(state, 'userId', ''),
  toAccountNo: get(state, 'toAccountNo', ''),
  accountLimit: get(state, 'accountLimit', ''),
  emailAddress: get(state, 'emailAddress', ''),
  accountNickname: get(state, 'accountNickname', ''),
  accountHolderName: get(state, 'accountHolderName', ''),
});

export const getIntrabankNewFavPayload = state => ({
  userId: get(state, 'userId', ''),
  toAccountNo: get(state, 'toAccountNo', ''),
  currencyCode: get(state, 'currencyCode', ''),
  accountLimit: get(state, 'accountLimit', ''),
  emailAddress: get(state, 'emailAddress', ''),
  accountNickname: get(state, 'accountNickname', ''),
  accountHolderName: get(state, 'accountHolderName', ''),
});
